import './App.css';
import Piano from './components/piano.js';
import Play from './components/play.js';
import Score from './components/score.js';
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Score/>
        <Piano/>
        <Play/>
      </header>
    </div>
  );
}

export default App;
